


















































































import Vue, { VNode } from 'vue';
import { RoleService } from '@/services/RoleService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ModalHelpers } from '@/mixins';
import { ConfirmationModalSettings, ModalConstants } from '@/types';
import MStorePickList from '@/components/shared/MStorePickList.vue';
import { StandardRole, BuiltInUsers } from '@/types/enums';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { RoleModel } from '@/services/GeneratedApi';

export default Vue.extend({
  name: 'ViewRole',
  mixins: [ModalHelpers],
  data() {
    return {
      role: {} as RoleModel,
      isLoading: true,
      hasError: false,
      errorMessage: '',
      isDeactivated: false,
      picklistFields: [
        {
          key: 'username',
          label: 'Username',
          sortable: true
        },
        {
          key: 'name',
          label: 'Fullname',
          sortable: true
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      fixedItems: [BuiltInUsers.Administrator, BuiltInUsers.ControllerUser]
    };
  },
  methods: {
    async getRole(this: any) {
      this.isLoading = true;
      RoleService.getRoleAsync(this.$route.params.id).then((result: any) => {
        this.role = result;
        this.isLoading = false;
      });
    },
    async deleteRole(this: any) {
      this.loading = true;
      const message = await this.deleteConfirmaionMessage();
      const confirmationModalSettings: ConfirmationModalSettings = {
        okTitle: ModalConstants.deleteConfirmationText,
        isHtml: true
      };
      await this.showConfirmationModalAsync(this.$bvModal, message, confirmationModalSettings).then(async (result: boolean) => {
        if (result) {
          await RoleService.deleteRoleAsync(this.role.id).then((response) => {
            SnotifyConfiguration.showSuccess(`${this.role.name} role deleted successfully.`);
            this.$router.push({ name: 'roleManagement' });
          });
        }
      });
    },
    async deleteConfirmaionMessage(this: any): Promise<string> {
      const h = this.$createElement;
      const userCount = (await RoleService.getUsersAsync(this.role.id)).length;
      const userConfirmation = userCount === 0 ? `Are you sure you want to delete <b>${this.role.name}</b> role?` : `There are <b>${userCount}</b> users in the <b>${this.role.name}</b> role.`;

      const organisationCount = this.role.organisations.length;
      const organisationconfirmaion =
        organisationCount === 0
          ? ''
          : organisationCount === 1
          ? `<b>${this.role.name}</b> role is also the default role for the 
          <b>${this.role.organisations[0].name}</b> organisation`
          : `<b>${this.role.name}</b> role is also the default role for the 
          <b>${this.role.organisations[0].name}</b> organisation and 
          <b>${organisationCount - 1}</b> others`;
      return `${userConfirmation}<br><br>${organisationconfirmaion}`;
    },
    navigate(routeName: any) {
      this.$router.push({ name: routeName });
    },
    saveUsers(newusers: any) {
      RoleService.updateRoleUserssync({
        role: this.role,
        users: newusers
      })
        .then((result: any) => {
          SnotifyConfiguration.showSuccess('Role users updated successfully.');
        })
        .catch((error: any) => {
          SnotifyConfiguration.showError('Save changes failed.');
        });
    }
  },
  mounted(this: any) {
    this.getRole();
  },
  components: {
    MStorePickList,
    LoadingSpinner
  }
});
